import React, { useEffect } from "react";
import "./css/IntroScreen.css";

const IntroScreen = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish(); // Trigger transition to homepage
    }, 5000); // Show intro for 3 seconds

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="intro-screen">
      <img src="/vyral.png" alt="Vyral Logo" className="intro-logo" />
      <h1 className="intro-text">Vyral Media Group</h1>
    </div>
  );
};

export default IntroScreen;